import { render, staticRenderFns } from "./ControlTask.vue?vue&type=template&id=538b0d3c"
import script from "./ControlTask.vue?vue&type=script&lang=ts"
export * from "./ControlTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports